<script>
import {ref} from "vue";
import axios from "axios";
import Swals from "@/assets/js/Swals";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import {da} from "vuetify/locale";
import FreeWorld from "@/assets/js/FreeWorld";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "ProductProposal",
  computed: {
    da() {
      return da
    }
  },
  components: {LoadingPage, LoadingPic},
  setup(){

    let loading_pic = ref()
    let loading = ref(false)

    let show_pic = ref({
      pic1: null,
      pic2: null,
      pic3: null,
      pic4: null,
    })

    let data_offer = ref({
      name:'',
      description: '',
      unit: '',
      brand: '',
      pic1: null,
      pic2: null,
      pic3: null,
      pic4: null,
    })


    function upload_pic(id) {

      const file = document.getElementById(id).files[0];
      if (file !== undefined) {

        loading_pic.value = id
        axios.post(localStorage.getItem('DOM') + "upload", {
              file: file,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res)=>{

          loading_pic.value = null
          if (res.data.status === 'ok') {
           if (id === 'pic1') {show_pic.value.pic1 = URL.createObjectURL(file); data_offer.value.pic1 = res.data.url}
           if (id === 'pic2') {show_pic.value.pic2 = URL.createObjectURL(file); data_offer.value.pic2 = res.data.url}
           if (id === 'pic3') {show_pic.value.pic3 = URL.createObjectURL(file); data_offer.value.pic3 = res.data.url}
           if (id === 'pic4') {show_pic.value.pic4 = URL.createObjectURL(file); data_offer.value.pic4 = res.data.url}
          }else {
            Swals.Fault('لطفا از فرمت عکس مورد نظر اطمینان حاصل فرمایید!')
          }

        }).catch((res) => {
          loading_pic.value = null
          Swals.Catch(res , ()=>{upload_pic(id)})
        })
      }


    }

    function delete_pic(id) {

      if (id === 'pic1') {show_pic.value.pic1 = null; data_offer.value.pic1 = null}
      if (id === 'pic2') {show_pic.value.pic2 = null; data_offer.value.pic2 = null}
      if (id === 'pic3') {show_pic.value.pic3 = null; data_offer.value.pic3 = null}
      if (id === 'pic4') {show_pic.value.pic4 = null; data_offer.value.pic4 = null}

    }

    function add_ProductProposal() {

      if (data_offer.value.name.trim().length === 0){Swals.Warning('لطفا نام محصول پیشنهادی خود را وارد کنید!');return false}
      if (data_offer.value.description.trim().length === 0){Swals.Warning('لطفا توضیحات محصول پیشنهادی خود را وارد کنید!');return false}
      if (data_offer.value.unit.trim().length === 0){Swals.Warning('لطفا واحد محصول پیشنهادی خود را وارد کنید!');return false}
      if (data_offer.value.brand.trim().length === 0){Swals.Warning('لطفا برند محصول پیشنهادی خود را وارد کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(data_offer.value , 'shop/offer_product' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('محصول پیشنهادی شما با موفقیت ثبت شد' , 'HomePage')
        }else {
          Swals.Fault('متاسفانه محصول پیشنهادی شما ثبت نشد' , 'HomePage')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , add_ProductProposal)
      })

    }

    return{

      upload_pic,
      data_offer,
      show_pic,
      loading_pic,
      delete_pic,
      add_ProductProposal,
      loading,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">پیشنهاد محصول به اپلیکیشن</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body w-100 ">

      <div class="mt-4">
        <p class="me-2 mb-2 font-5 font-bold font-color">نام محصول پیشنهادی</p>
        <input v-model="data_offer.name" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="me-2 mb-2 font-5 font-bold font-color">توضیحات محصول</p>
        <textarea v-model="data_offer.description" style="min-height: 100px;resize: none" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2" type="text"></textarea>
      </div>

      <div class="mt-4">
        <p class="me-2 mb-2 font-5 font-bold font-color">واحد محصول</p>
        <input v-model="data_offer.unit" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-4">
        <p class="me-2 mb-2 font-5 font-bold font-color"> برند محصول</p>
        <input v-model="data_offer.brand" class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="text">
      </div>

      <div class="mt-13 w-100 d-flex justify-content-between align-items-center">

        <div class="position-relative img_prod">
          <input @change="upload_pic('pic1')" id="pic1" type="file" style="display: none">
            <img @click="delete_pic('pic1')" v-if="show_pic.pic1 !== null" style="top: -5px;left: -5px;z-index: 2" class="animate__animated animate__fadeIn w-33 position-absolute" src="../assets/img/close_color.svg" alt="">
          <label for="pic1" :class="show_pic.pic1 !== null ? 'pe-none':''" class="w-100 h-100 bg-white rounded-4 d-flex justify-content-center align-items-center shadow-custom position-relative">
            <LoadingPic v-if="loading_pic ==='pic1'"></LoadingPic>

            <img v-if="show_pic.pic1 === null" src="../assets/img/add_pic.svg" class="h-100 w-100 rounded-4">
            <img v-else :src="show_pic.pic1" class="animate__animated animate__fadeIn h-100 w-100 rounded-4">
          </label>
        </div>

        <div class="position-relative img_prod">
          <input @change="upload_pic('pic2')" id="pic2" type="file" style="display: none">
            <img @click="delete_pic('pic2')" v-if="show_pic.pic2 !== null" style="top: -5px;left: -5px;z-index: 2" class="animate__animated animate__fadeIn w-33 position-absolute" src="../assets/img/close_color.svg" alt="">
          <label for="pic2" :class="show_pic.pic2 !== null ? 'pe-none':''" class="w-100 h-100 bg-white rounded-4 d-flex justify-content-center align-items-center shadow-custom position-relative">

            <LoadingPic v-if="loading_pic ==='pic2'"></LoadingPic>

            <img v-if="show_pic.pic2 === null" src="../assets/img/add_pic.svg" class="h-100 w-100 rounded-4">
            <img v-else :src="show_pic.pic2" class="h-100 w-100 rounded-4">
          </label>
        </div>

        <div class="position-relative img_prod">
          <input @change="upload_pic('pic3')" id="pic3" type="file" style="display: none">
            <img @click="delete_pic('pic3')" v-if="show_pic.pic3 !== null" style="top: -5px;left: -5px;z-index: 2" class="animate__animated animate__fadeIn w-33 position-absolute" src="../assets/img/close_color.svg" alt="">
          <label for="pic3" :class="show_pic.pic3 !== null ? 'pe-none':''" class="w-100 h-100 bg-white rounded-4 d-flex justify-content-center align-items-center shadow-custom position-relative">
            <LoadingPic v-if="loading_pic ==='pic3'"></LoadingPic>

            <img v-if="show_pic.pic3 === null" src="../assets/img/add_pic.svg" class="h-100 w-100 rounded-4">
            <img v-else :src="show_pic.pic3" class="h-100 w-100 rounded-4">
          </label>
        </div>

        <div class="position-relative img_prod">
          <input @change="upload_pic('pic4')" id="pic4" type="file" style="display: none">
            <img @click="delete_pic('pic4')" v-if="show_pic.pic4 !== null" style="top: -5px;left: -5px;z-index: 2" class="animate__animated animate__fadeIn w-33 position-absolute" src="../assets/img/close_color.svg" alt="">
          <label for="pic4" :class="show_pic.pic4 !== null ? 'pe-none':''" class="w-100 h-100 bg-white rounded-4 d-flex justify-content-center align-items-center shadow-custom position-relative">
            <LoadingPic v-if="loading_pic ==='pic4'"></LoadingPic>

            <img v-if="show_pic.pic4 === null" src="../assets/img/add_pic.svg" class="h-100 w-100 rounded-4">
            <img v-else :src="show_pic.pic4" class="h-100 w-100 rounded-4">
          </label>
        </div>

      </div>
    </div>

    <br>
    <br>
    <br>
    <br>
    <div class="p-body w-100 max_width position-fixed bottom-0 d-flex justify-content-center">
      <v-btn @click="add_ProductProposal" class="py-3 mb-4 h-100 w-100 border-0 rounded-3 bg-color text-white">ثبت نهایی</v-btn>
    </div>

  </div>

</template>


<style scoped>
@media (min-width: 800px) {
  .img_prod{
    height: 11rem !important;
  }
}
.img_prod{
  width: 23%;
  height: 7rem;
}
</style>